export default () => ({
  isDraftsFetched: false,
  drafts: [],
  isPublishing: false,
  currentlyPublishingDrafts: [],
  shouldAnimateReviewButton: false,
  reviewBarRendered: false,
  isMergeRequest: false,
});
